import { ITranslationTypes } from './../../store/actions/translation-types.actions';
import { Component, OnDestroy } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { TranslationType } from '../../models/translation-type';
import { Store } from '@ngrx/store';
import { TranslationTypesActions } from '../../store/actions/translation-types.actions';
import { Title } from '@angular/platform-browser';
import { User } from '../../models/user';
import { Subscription } from 'rxjs/Subscription';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-translate',
  templateUrl: './translate.component.html',
  styleUrls: ['./translate.component.scss']
})
export class TranslateComponent implements OnDestroy {

  loading: boolean;
  translationTypes: TranslationType[];
  activeTranslationType: TranslationType;
  subscriptions: Subscription[];
  currentUser: User;

  /**
   * Initialize variables and load data
   * @param {TranslationService} translationService
   * @param {TranslationTypesActions} translationTypesActions
   * @param {Store<any>} store
   * @param {Title} title
   */
  constructor(private translationService: TranslationService,
    private translationTypesActions: TranslationTypesActions,
    private store: Store<any>,
    private title: Title,
    private sidenavService: SidenavService) {

    /**
     * Set the page title
     */
    this.title.setTitle('Taiga - Translate');
    this.sidenavService.currentTab = 'Translate';

    this.loading = true;

    this.subscriptions = [];

    /**
     * Get the translation types from the store
     */
    this.subscriptions.push(this.store.select('translationTypesState').subscribe((translations: ITranslationTypes) => {
      this.translationTypes = translations.translationTypes;
    }));

    this.getCurrentUser();
  }

  /**
   * Get the current user from the store
   */
  getCurrentUser() {
    this.subscriptions.push(this.store.select('userState').subscribe((user: User) => {
      if (user && user.currentLanguage) {
        this.currentUser = user;
        this.getTranslationTypes();
      }
    }));
  }

  /**
   * Fetch the translation types from the API
   */
  getTranslationTypes() {
    if (this.translationTypes.length === 0) {
      this.translationService.getTranslationTypes(this.currentUser.currentLanguage).subscribe((translationTypes: TranslationType[]) => {
        this.translationTypesActions.setTranslationTypes(translationTypes);
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  /**
   * On destroy, unsubscribe all subscriptions
   */
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/translate/translate.component.ts